import { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../utils/store';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import { Box, Button, Paper, Typography } from '@mui/material';
import AddButtonComponent from '../../../components/form/AddButtonComponent';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import SimpleDialogComponent from '../../../components/SimpleDialogComponent';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import CriticalChecksList from './CriticalChecksList';
import PaginateDataModel from '../../../Models/PaginateDataModel';
import SimpleSearchComponent from '../../../components/SimpleSearchComponent';
import { useAlert } from '../../../components/alertContext';

interface ProjectCriticalChecksProps {
  projectInternalId: number;
}
const ProjectCriticalChecks: React.FC<ProjectCriticalChecksProps> = ({
  projectInternalId,
}) => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const [searchQueryCritical, setSearchQueryCritical] = useState<any>('');
  const [totalRecordsCritical, setTotalRecordsCritical] = useState<number>(0);
  const [critcalList, setCritcalList] = useState<any>([]);
  const [selectedCriticalList, setSelectedCriticalList] = useState<any>([]);
  const [selectedCriticalListIds, setSelectedCriticalListIds] = useState<any>(
    []
  );

  const [paginateCriticalList, setPaginateCriticalList] =
    useState<PaginateDataModel>({
      limit: Constants.DEFAULT_PAGE_SIZE,
      offset: 0,
    });
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Activity',

      renderCell: (value: any, row: any) => row.criticalCheck.activity,
    },
    {
      field: 'id',
      headerName: 'Inspection Point',
      renderCell: (value: any, row: any) => row.criticalCheck.inspectionPoint,
    },
    {
      field: 'id',
      headerName: 'Test Method',
      renderCell: (value: any, row: any) => row.criticalCheck.testMethod,
    },
    {
      field: 'id',
      headerName: 'Acceptance Criteria',
      renderCell: (value: any, row: any) =>
        row.criticalCheck.acceptanceCriteria,
    },
    {
      field: 'id',
      headerName: 'Responsible Party',
      renderCell: (value: any, row: any) => row.criticalCheck.responsibleParty,
    },
    {
      field: 'id',
      headerName: ' Hold Point (HP)/ Witness Point (WP)',
      renderCell: (value: any, row: any) => row.criticalCheck.holdWitnessPoint,
    },
  ];

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });

  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [addNewDialogOpen, setAddNewDialogOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);

  /* Critical List Operations Starts Here */
  const fetchCriticalList = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.criticalcheckURL}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          search: searchQueryCritical,
          limit: paginateCriticalList.limit,
          offset: paginateCriticalList.offset,
          isActive: 1,
        }
      );
      if (response.success) {
        setCritcalList(response.data.paginateRecords);
        setTotalRecordsCritical(response.data.total);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      fetchCriticalList();
    }
  }, [projectInternalId]);

  const fetchSelectedCriticalList = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.projectDashboardsURL}/${projectInternalId}/criticalcheck`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        setSelectedCriticalList(response.data.projectCriticalChecks);
        const idArray = response.data.projectCriticalChecks.map(
          (item: any) => item.criticalCheck.id
        );
        setTotalRecords(response.data.projectCriticalChecks.length);
        console.log(idArray, '<<<<<<<<<<<<<<<<<');
        setSelectedCriticalListIds(idArray);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleSaveCritical = async () => {
    try {
      setIsLoading(true);
      const response = await HttpService.post(
        `${Constants.apiURL}${Constants.projectDashboardsURL}/${projectInternalId}/criticalcheck`,
        { criticalCheckIds: selectedCriticalListIds },
        { headers: { Authorization: `Bearer ${getAdmin()}` } }
      );
      if (response.success) {
        await fetchSelectedCriticalList();
        setAddNewDialogOpen(false);
      }
      setIsLoading(false);
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const AddDialogContent = () => {
    return (
      <Box className="row mb-3 mt-2" sx={{ textAlign: 'right' }}>
        <Typography component={'h1'} sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
          Add Critical Check List
        </Typography>
        <Box sx={{ width: '800px' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              mt: 2,
            }}
          >
            <SimpleSearchComponent
              onSearch={(event: any) => {
                setSearchQueryCritical(event.target.value);
              }}
              search={searchQueryCritical}
            />
          </Box>
          <CriticalChecksList
            handleStatus={handleStatus}
            recordList={critcalList}
            selectedRecords={selectedCriticalListIds}
            totalRecords={totalRecordsCritical}
            paginate={paginateCriticalList}
            handlePagination={handlePaginationCritical}
          ></CriticalChecksList>
        </Box>
        <Button
          disabled={isLoading}
          color="primary"
          sx={{ color: '#fff !important', mt: 3, mb: 3, textAlign: 'right' }}
          variant="contained"
          onClick={handleSaveCritical}
        >
          {isLoading ? 'Saving' : 'Save'}
        </Button>
      </Box>
    );
  };

  const handleStatus = (row: any) => {
    handleSelectedIds(row.id);
  };
  const handleSelectedIds = async (id: any) => {
    console.log(id);

    setSelectedCriticalListIds((prevItems: any) => {
      const newItems = [...prevItems];
      if (!newItems.includes(id)) {
        newItems.push(id);
      } else {
        newItems.splice(newItems.indexOf(id), 1);
      }
      return newItems;
    });
  };
  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };
  const handlePaginationCritical = (paginationData: any) => {
    console.log(paginationData);
    setPaginateCriticalList(paginationData);
  };

  useEffect(() => {
    if (paginate || isInitialLoad.current) {
      fetchSelectedCriticalList();
    }
    isInitialLoad.current = false;
  }, [paginate]);

  return (
    <div className="containergrid">
      <div className="mt-2">
        <Paper sx={{ width: '100%' }} className="mt-4">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              mb: 2,
            }}
          >
            <Typography variant="h6">Critical Checks</Typography>
            <Box>
              <AddButtonComponent
                onClick={() => {
                  setAddNewDialogOpen(true);
                }}
                keyName="checkIcon"
                label="Add Critical"
              />
            </Box>
          </Box>
          <CustomPaginationActionsTable
            rows={selectedCriticalList}
            columns={columns}
            totalRecords={totalRecords}
            handlePagination={handlePagination}
            handleRowClick={(row) => {
              console.log('row-clicked');
            }}
            paginationModel={{
              page: paginate.offset,
              pageSize: paginate.limit,
            }}
            handleStatus={handleStatus}
          />
          <SimpleDialogComponent
            title={''}
            dialogContent={AddDialogContent()}
            open={addNewDialogOpen}
            handleClose={() => {
              setAddNewDialogOpen(false);
            }}
          />
          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </div>
    </div>
  );
};

export default ProjectCriticalChecks;
